import React, { useContext, useEffect, useState } from 'react';
import { CButton, CCard, CCardHeader, CCol, CRow, CModal, CModalHeader, CModalBody, CModalFooter } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import DownloadExcel from 'src/reusables/DownloadExcel';
import { useNavigate } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import formatter from 'src/reusables/formatter';
import { getAll } from 'src/services/Suppliers';
import { Toaster } from 'src/components/Toaster';
import ls from 'local-storage';
import Authentication, { AUTH_KEY } from 'src/utils/auth/Authentication';
import { AuthContext } from 'src/App';
function Suppliers() {
  const [dataRows, setDataRows] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [color, setColor] = useState('');
  const navigate = useNavigate();
  const Auth = useContext(AuthContext);
  async function fetchMainData() {
    const res = await getAll();
    const rows =
      res.suppliers &&
      res.suppliers.map((item, i) => {
        return {
          no: i + 1,
          id: item.id,
          name: item.name,
          address: item.address,
          email: item.email,
          phone: item.phone
        };
      });

    setDataRows(rows);

    const columns = [
      { field: 'no', headerName: 'No', width: '50' },
      { field: 'name', headerName: 'Nama', width: '300' },
      { field: 'address', headerName: 'Alamat', width: '100' },
      { field: 'email', headerName: 'Email', width: '100' },
      { field: 'phone', headerName: 'HP', width: '100' }
    ];

    setDataColumns(columns);
  }

  useEffect(() => {
    fetchMainData();
  }, []);

  function handleRowClick(params) {
    navigate('/supplier-actions', { state: params.row });
  }

  return (
    <div style={{ color: 'black' }}>
      <Toaster open={open} message={message} setOpen={setOpen} ahd={1500} color={color ?? 'red'} />

      <CCard>
        <CCardHeader>
          <CRow className="mb-3">
            <CCol xs={7} lg={7}>
              <h4> Daftar Supplier </h4>
            </CCol>
            <CCol xs={5} lg={5} style={{ textAlign: 'right' }}>
              <CButton
                style={{ borderColor: 'primary' }}
                onClick={() => {
                  navigate('/supplier-actions');
                }}
              >
                Tambah
              </CButton>
              &nbsp;
              {/* {Auth.isAllowed(Auth.role[AUTH_KEY.export_reports]) && (
                <DownloadExcel
                  rows={dataRows}
                  columns={dataColumns}
                  excelName="Daftar Produk"
                  config={{ width: '20' }}
                />
              )} */}
              <DownloadExcel
                rows={dataRows}
                columns={dataColumns}
                excelName="Daftar Supplier"
                config={{ width: '20' }}
              />
            </CCol>
          </CRow>
        </CCardHeader>
        <div style={{ margin: '16px' }}>
          <DataGrid
            rows={dataRows}
            columns={dataColumns}
            onRowClick={handleRowClick}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 }
              }
            }}
            pageSizeOptions={[5, 10, 20, 25]}
            style={{ textAlign: 'center' }}
          />
        </div>
      </CCard>
    </div>
  );
}

export default Suppliers;
